import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Main from '@/modules/Main/Main.vue'
import HomeView from '@/views/Home/HomeView.vue'
import AboutView from '@/views/About/AboutView.vue'
import CekAntrianView from '@/views/CekAntrian/CekAntrianView.vue'
import DaftarView from '@/views/Daftar/DaftarView.vue'
import MjknView from '@/views/Mjkn/MjknView/MjknView.vue'

const routes: Array<RouteRecordRaw> = [
  //Main===========================================================
  {
    path: '/',
    name: 'Main',
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        component: HomeView
      },
      {
        path: '/cekantrian',
        name: 'cekantrian',
        component: CekAntrianView
      },
      {
        path: '/daftar',
        name: 'daftar',
        component: DaftarView
      },
      {
        path: '/about',
        name: 'about',
        component: AboutView
      },
      {
        path: '/mjkn',
        name: 'mjkn',
        component: MjknView
      },
      
    ]
  }
  
  //Main===========================================================
]

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),//
  routes,
  linkActiveClass: 'font-bold',
  linkExactActiveClass: ''
})

export default router
